<template>
  <v-container fill-height>
    <v-row align="center" justify="center">
      <v-card :max-width=" $vuetify.breakpoint.lgAndUp ? '80%' : '90%'" :elevation="24">
        <v-img
          class="white--text align-center"
          src="@/assets/trame.jpg"
          max-height="400"
          height="30%"
        >
          <h1
            class="tk-pragmatica px-8 text-center"
            :class="$vuetify.breakpoint.mdAndUp ? 'text-h1' : $vuetify.breakpoint.smAndUp ? 'text-h2' : 'text-h4'"
          >
            {{ $t('TBC Admin Portal') }}
            <span class="dot primary"></span>
          </h1>
        </v-img>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "WelcomePage"
};
</script>

<style>
.dot {
  display: inline-block;
  width: 0.17em;
  height: 0.17em;
  border-radius: 50%;
  margin-left: 0em;
  margin-bottom: -0.02em;
}
</style>